import { render, staticRenderFns } from "./WorkPlaceSelect.vue?vue&type=template&id=5df48198&scoped=true&"
import script from "./WorkPlaceSelect.vue?vue&type=script&lang=js&"
export * from "./WorkPlaceSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df48198",
  null
  
)

export default component.exports